import { FormEvent, useState } from 'react'
import { useRouter } from 'next/router'
import Link from 'next/link'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { useMutation } from '@tanstack/react-query'
import Callback from './Callback'
import apiService from '../../../utils/helpers/apiService'
import Input from '../../Common/Input/Input'
import toast from 'react-hot-toast'
import Logo from '../../Common/Logo/Logo'

const ForgotPasswordWrapper: React.FC = () => {
  const [emailInput, setEmailInput] = useState('')
  const router = useRouter()

  const { email: userEmail, token } = router.query

  const forgotPasswordMutation = useMutation({
    mutationFn: () => {
      return apiService.post({
        url: '/users/forgot-password/',
        config: {
          data: {
            email: emailInput,
          },
        },
        withToken: false,
      })
    },
    onSuccess: () => {
      router.push('/auth?redirectFromForgot=true ')
    },
  })

  function isValidEmail(email: string): boolean {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
    return emailRegex.test(email)
  }

  const submitHandler = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (!emailInput) {
      toast.error('Please enter your email')
      return
    }
    // Validate email input here
    if (!isValidEmail(emailInput)) {
      toast.error('Please enter a valid email')
      return
    }

    forgotPasswordMutation.mutate()
  }

  return (
    <>
      {userEmail && token ? (
        <Callback />
      ) : (
        <>
          <Stack
            className="default-form"
            width={1}
            component={'form'}
            onSubmit={submitHandler}
          >
            <Box mb={5}>
              <Link href={'https://jobin.ai'}>
                <Logo />
              </Link>
            </Box>
            <Typography variant="h5_xl" mb={1.25}>
              Forgot Password?
            </Typography>
            <Stack spacing={3.75}>
              <Typography variant="body_m_regular" color={'darkGray.main'}>
                Enter the email address and we’ll send you a mail to reset your
                password.
              </Typography>
              <Input
                type="email"
                id="email"
                label="Email"
                autoFocus
                placeholder="johndoe@gmail.com"
                value={emailInput}
                onChange={e => setEmailInput(e.target.value)}
                required
              />
            </Stack>
            <Button
              sx={{
                mt: 5,
              }}
              type="submit"
            >
              Send Email
            </Button>
          </Stack>
        </>
      )}
    </>
  )
}

export default ForgotPasswordWrapper
